var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paymentMethods"},[_c('h4',[_vm._v("Accepted payment methods:")]),_vm._l((_vm.paymentdata),function(method,index){return _c('ul',{key:index},[_c('li',[_vm._v(_vm._s(_vm.capitatalize(method)))])])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }